export default "__VITE_ASSET__8be9dd2a__"